import { type ExperienceItem } from "@/components/design-system/ExperienceCard/ExperienceCard";

export const cards: readonly ExperienceItem[] = [
  {
    image: "/wm-participant-1.png",
    title: "Answers, not articles",
    description:
      "Memory-enabled conversations that understand each participant's 401(k), held-away accounts, and financial goals — getting smarter every session.",
  },
  {
    image: "/wm-participant-2.png",
    title: "Full picture, one place",
    description:
      "Account aggregation pulls in outside IRAs, brokerage positions, and idle cash — giving participants a complete view and your advisors a discovery edge.",
  },
  {
    image: "/wm-participant-3.png",
    title: "Responsible guidance",
    description:
      "Compliance guardrails built in. Bravo never gives regulated advice — it guides, informs, and refers to your advisors at exactly the right moment.",
  },
  {
    image: "/wm-participant-4.png",
    title: "Meetings that matter",
    description:
      "With participant-permissioned context shared ahead of every meeting, advisors arrive informed — so time is spent on advice, not discovery.",
  },
];
